/*
  ============================================================
  TEKNO MASTER — TOOLTIP PARA TARJETAS DE PRODUCTO
  Archivo: assets/tm-card-tooltip.js

  Mobile:
  - Al tocar el icono flotante, abre o cierra la franja.
  - Evita que el toque abra accidentalmente el producto.
  - Cierra otros tooltips que estén abiertos.
  - Cierra al tocar fuera o presionar Escape.
  ============================================================
*/

(() => {
  const TOOLTIP_SELECTOR = "[data-tm-card-tooltip]";
  const TRIGGER_SELECTOR = "[data-tm-card-tooltip-trigger]";

  /**
   * Cierra un tooltip específico.
   */
  function closeTooltip(tooltip) {
    if (!tooltip) return;

    tooltip.classList.remove("is-open");

    const trigger = tooltip.querySelector(TRIGGER_SELECTOR);

    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
      trigger.setAttribute(
        "aria-label",
        "Mostrar información del producto"
      );
    }
  }

  /**
   * Cierra todos los tooltips, excepto uno opcional.
   */
  function closeAllTooltips(exceptTooltip = null) {
    document.querySelectorAll(TOOLTIP_SELECTOR).forEach((tooltip) => {
      if (tooltip !== exceptTooltip) {
        closeTooltip(tooltip);
      }
    });
  }

  /**
   * Abre o cierra el tooltip al tocar el icono móvil.
   * Se usa delegación de eventos para que funcione también
   * en secciones recargadas dinámicamente por Shopify.
   */
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(TRIGGER_SELECTOR);

    if (trigger) {
      event.preventDefault();
      event.stopPropagation();

      /*
       * Evita que otros eventos de la tarjeta abran
       * el producto, favoritos o compra rápida.
       */
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }

      const tooltip = trigger.closest(TOOLTIP_SELECTOR);

      if (!tooltip) return;

      const shouldOpen = !tooltip.classList.contains("is-open");

      closeAllTooltips(tooltip);

      tooltip.classList.toggle("is-open", shouldOpen);

      trigger.setAttribute(
        "aria-expanded",
        shouldOpen ? "true" : "false"
      );

      trigger.setAttribute(
        "aria-label",
        shouldOpen
          ? "Ocultar información del producto"
          : "Mostrar información del producto"
      );

      return;
    }

    /*
     * Cierra los tooltips cuando se toca fuera.
     */
    if (!event.target.closest(TOOLTIP_SELECTOR)) {
      closeAllTooltips();
    }
  });

  /**
   * Impide que el toque móvil sobre el botón se propague
   * antes de que ocurra el evento click.
   */
  document.addEventListener(
    "pointerdown",
    (event) => {
      const trigger = event.target.closest(TRIGGER_SELECTOR);

      if (!trigger) return;

      event.stopPropagation();
    },
    true
  );

  /**
   * Cierra todos con la tecla Escape.
   */
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeAllTooltips();
    }
  });

  /**
   * Al pasar de mobile a desktop, elimina cualquier
   * estado abierto que haya quedado activo.
   */
  window.addEventListener("resize", () => {
    if (window.innerWidth >= 750) {
      closeAllTooltips();
    }
  });

  /**
   * Cierra los tooltips cuando Shopify recarga una sección
   * dentro del editor visual del tema.
   */
  document.addEventListener("shopify:section:load", () => {
    closeAllTooltips();
  });
})();